import { TextField } from "@mui/material";
import { styled } from "@mui/material/styles";
import { black, mainFont, trueBlue } from "../../utils/StyleHelpers";

export const StyledTextField = styled(TextField)({
  "& label": {
    fontFamily: `${mainFont}`,
    fontStyle: "normal",
    fontWeight: "500",
    lineHeight: "normal",
  },
  "& label.Mui-focused": {
    color: `${black}`,
  },
  "& .MuiOutlinedInput-root": {
    "& fieldset": {
      borderRadius: "0.5rem",
      border: `2px solid ${black}`,
      display: "flex",
      alignItems: "center",
      gap: "1.875rem",
      alignSelf: "stretch",
      textOverflow: "ellipsis",
      fontFamily: `${mainFont}`,
      fontSize: "1rem",
      fontStyle: "normal",
      fontWeight: "500",
      lineHeight: "normal",
    },
    "&:hover fieldset": {
      borderColor: `${trueBlue}`,
    },
    "&.Mui-focused fieldset": {
      borderColor: `${trueBlue}`,
    },
  },
});
